import { AxiosRequestConfig } from "axios";
import axiosInstance from "./axiosInstance";

export const Cancelled: string = "Cancelled";
type MethodType = "get" | "post" | "put" | "delete";

const request = async (
  url: string,
  method: MethodType,
  data: any,
  options: AxiosRequestConfig
): Promise<any> => {
  const optionsObj = {
    ...options,
  };

  if (["put", "post"].includes(method)) {
    return axiosInstance[method](url, data, optionsObj);
  }

  return axiosInstance[method](url, optionsObj);
};

export default request;
